/**
 * Canonical facts about the site, shared by every machine-readable surface
 * (JSON-LD, llms.txt, robots.txt, sitemap.xml, markdown content negotiation).
 *
 * Keeping one source of truth is what makes the brand name, description and
 * canonical URL identical everywhere an agent might look.
 */

/** Inlined by `web/next.config.ts`, so the browser bundle sees it too. */
const productionHost = process.env.VERCEL_PROJECT_PRODUCTION_URL;

export const SITE = {
  /** Product name, used on its own wherever a short brand is expected. */
  name: "Setlist",
  /** Fully qualified brand, disambiguating the generic product name. */
  fullName: "Setlist by MooseDev",
  /** Organisation that publishes the product. */
  publisher: "MooseDev",
  publisherUrl: "https://moosedev.app",
  /**
   * Canonical origin, without a trailing slash: the project's production
   * domain as Vercel reports it, on every deployment — canonical links and the
   * sitemap should name production even when served from staging or a
   * preview. Off Vercel (local dev, CI) it is localhost. Link-preview cards,
   * which need the serving host instead, derive it per request
   * (`requestOrigin` in `app/api/link-preview/_lib/preview-request.ts`).
   */
  url: productionHost ? `https://${productionHost}` : "http://localhost:3000",
  tagline: "Chord sheets for the whole band",
  description:
    "Setlist by MooseDev is a realtime, multiplayer chord sheet app for bands and worship teams. Write chord charts in the Nashville Number System, transpose any song instantly, share a live link with the whole band, and run rehearsals with a built-in metronome and drone pad.",
  /** Short description for meta tags, which are truncated around 160 chars. */
  shortDescription:
    "Realtime multiplayer chord sheets for bands. Nashville Number System, instant transpose, arrangements, metronome and drone pad — free to use.",
  sameAs: ["https://instagram.com/moosedevapps"],
} as const;

/** Absolute URL for a site-relative path. */
export function absoluteUrl(path: string): string {
  return path === "/" ? `${SITE.url}/` : `${SITE.url}${path}`;
}
